import React from 'react';
import { motion } from 'framer-motion';

export default function PersonalizedTestimonials() {

  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 to-slate-800">
      <div className="container mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16">

          <h2 className="text-4xl lg:text-5xl font-light text-white mb-6">
            Patient <span className="font-serif italic text-amber-400">Testimonials</span>
          </h2>
          <p className="text-lg text-slate-300">
            Real experiences from patients who transformed their smiles at Trinity Dental Arts
          </p>
        </motion.div>

        <div className="max-w-5xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="bg-white rounded-3xl p-6 lg:p-8 shadow-2xl">
            <div className="aspect-video w-full">
              <iframe
                width="100%"
                height="100%"
                src="https://www.youtube-nocookie.com/embed/59PC9_p-dhU?list=PLpwGsGNql5xT1pqNdSQcYe44-NBnfB4g3&rel=0&playsinline=1"
                referrerPolicy="strict-origin-when-cross-origin"
                title="Patient Testimonials Playlist"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className="rounded-2xl"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>);

}